var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3001 25.9537C30.2369 26.8848 30.2369 28.4005 29.3001 29.3316C28.3713 30.2547 26.8714 30.2547 25.9427 29.3316L2.69882 6.22876C1.76202 5.29764 1.76202 3.78196 2.69882 2.85083C3.6276 1.92769 5.12748 1.92769 6.05625 2.85083L29.3001 25.9537Z",
    fill: "#E00D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05572 29.1492C5.12695 30.0723 3.62708 30.0723 2.6983 29.1492C1.76149 28.2181 1.76149 26.7024 2.6983 25.7713L25.9421 2.66852C26.8709 1.74538 28.3708 1.74538 29.2996 2.66852C30.2364 3.59964 30.2364 5.11533 29.2996 6.04645L6.05572 29.1492Z",
    fill: "#E00D7B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.4492eda4.svg";
export { ForwardRef as ReactComponent };